module.exports = __webpack_public_path__ + "img/12.1e1b9222.jpg";